var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-user-item-container"},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.formatTimeSplitted(_vm.item.lts)["time"]))]),_c('br'),_c('b',[_vm._v(_vm._s(_vm.formatTimeSplitted(_vm.item.lts)["date"]))])])])}
var staticRenderFns = []

export { render, staticRenderFns }